import { FONT_SOURCE } from '../components/pages/CreatePage/Preview/PreviewDisplayConstants';

const GOOGLE_FONT_WEIGHTS = '400;700';
export const createGoogleFontOption = (fontFamily) => ({
    value: fontFamily,
    text: fontFamily,
    font: fontFamily
});

export const resolveFontSource = (fontSource) => fontSource ?? FONT_SOURCE.SYSTEM;
export const isGoogleFontSource = (fontSource) => fontSource === FONT_SOURCE.GOOGLE_FONTS;

export const addSelectedFontToOptions = (options, selectedFont) => {
    if (!selectedFont || options.some(option => option.value === selectedFont))
        return options;

    return [...options, createGoogleFontOption(selectedFont)];
};

export const loadGoogleFont = (fontFamily) => {
    if (!fontFamily || typeof document === 'undefined')
        return;

    const normalizedFontFamily = fontFamily.trim();
    if (!normalizedFontFamily)
        return;

    const fontId = `google-font-${normalizedFontFamily.replace(/\s+/g, '-').toLowerCase()}`;
    if (document.getElementById(fontId)) return;

    const head = document.getElementsByTagName('head')[0];
    const link = document.createElement('link');
    link.id = fontId;
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(normalizedFontFamily)}:wght@${GOOGLE_FONT_WEIGHTS}&display=swap`;
    head.appendChild(link);
};
